
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Assignment": [
      "CollectiveAssignment",
      "IndividualAssignment"
    ],
    "BudgetRequestLogNode": [
      "BudgetRequestLog"
    ],
    "BudgetRequestNode": [
      "BudgetRequest",
      "BudgetRequestListItem"
    ],
    "CertificateNode": [
      "Certificate"
    ],
    "CollectionAccessType": [
      "Group",
      "TrainingListItem"
    ],
    "CommentSubscriptionType": [
      "CreatedCommentSubscriptionType",
      "DeletedCommentSubscriptionType",
      "UpdatedCommentSubscriptionType"
    ],
    "Condition": [
      "AbsoluteDateCondition",
      "CourseClearedCondition",
      "DeadlineCondition",
      "RelativeDateCondition"
    ],
    "CourseNode": [
      "CourseListItem"
    ],
    "CourseOrLTIModule": [
      "Course",
      "LTIModule"
    ],
    "ExternalContentNode": [
      "ExternalContent"
    ],
    "ExtraCategoryValue": [
      "ExtraCategoryBooleanValue",
      "ExtraCategoryChoiceValue",
      "ExtraCategoryDatetimeValue",
      "ExtraCategoryStringValue"
    ],
    "GroupNode": [
      "Group"
    ],
    "LibraryItem": [
      "LibraryArticle",
      "LibraryCollection"
    ],
    "LibrarySearchResult": [
      "Article",
      "Collection"
    ],
    "LocationNode": [
      "Location"
    ],
    "MenuBadge": [
      "StaticBadge",
      "UnreadBadge"
    ],
    "Module": [
      "AfasWebhookModule",
      "ArticleModule",
      "AssignmentModule",
      "CertificateModule",
      "CollectionModule",
      "CourseModule",
      "ExternalContentModule",
      "FileModule",
      "LTIModule",
      "LinkModule",
      "MeetingModule",
      "ScormModule",
      "VideoModule",
      "WebhookModule"
    ],
    "ModuleGroupCondition": [
      "AbsoluteModuleGroupCondition",
      "CourseCompletionModuleGroupCondition",
      "RelativeModuleGroupCondition"
    ],
    "Node": [
      "Collection",
      "User",
      "UserActivity"
    ],
    "NotificationNode": [
      "Notification"
    ],
    "OfferEventEnrollmentManageableNode": [
      "OfferEventEnrollmentManageable"
    ],
    "OfferEventEnrollmentNode": [
      "OfferEventEnrollment"
    ],
    "OfferEventNode": [
      "OfferEventListItem"
    ],
    "OfferEventSearchNode": [
      "OfferEventSearch"
    ],
    "OfferNode": [
      "Offer"
    ],
    "OfferSearchNode": [
      "OfferSearch"
    ],
    "OrganisationAdminNode": [
      "OrganisationAdmin"
    ],
    "OrganisationLogNode": [
      "OrganisationLog",
      "OrganisationLogListItem"
    ],
    "PortfolioItemRelatedObject": [
      "AssignmentModule",
      "Course",
      "ExternalContent",
      "LTIModule",
      "OfferEvent",
      "ReceivedCertificate",
      "Scorm",
      "Skill",
      "TrainingListItem"
    ],
    "PortfolioItemReportSearchNode": [
      "PortfolioItemReport"
    ],
    "ReceivedCertificateNode": [
      "ReceivedCertificate"
    ],
    "ScormNode": [
      "Scorm"
    ],
    "SkillNode": [
      "Skill",
      "SkillListItem"
    ],
    "TrainingExtraField": [
      "TrainingExtraChoiceField",
      "TrainingExtraDateField",
      "TrainingExtraStringField"
    ],
    "TrainingNode": [
      "Training",
      "TrainingListItem"
    ],
    "UserAssignmentNode": [
      "UserAssignment"
    ],
    "UserExtraField": [
      "UserExtraCheckboxField",
      "UserExtraChoiceField",
      "UserExtraDateField",
      "UserExtraStringField"
    ],
    "VideoNode": [
      "Video"
    ]
  }
};
      export default result;
    